"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { MERCHANT } from "@/lib/legalContent";

// Footer with legal links — rendered at the bottom of every in-app page (via AppShell)
// and on the standalone /legal page. Links deep-link to the matching document anchor.
const LEGAL_LINKS: {
  id: string;
  key: "about" | "terms" | "privacy" | "kvkk" | "consent" | "cookies" | "distanceSales" | "deliveryRefund";
}[] = [
  { id: "about", key: "about" },
  { id: "terms", key: "terms" },
  { id: "privacy", key: "privacy" },
  { id: "kvkk", key: "kvkk" },
  { id: "consent", key: "consent" },
  { id: "cookies", key: "cookies" },
  { id: "distance-sales", key: "distanceSales" },
  { id: "delivery-refund", key: "deliveryRefund" },
];

export function Footer({
  legalBase = "/legal",
  className = "",
}: { legalBase?: string; className?: string } = {}) {
  const t = useTranslations("footer");
  const year = new Date().getFullYear();

  return (
    <footer className={`mt-auto border-t border-[var(--border)] bg-[var(--sidebar-bg)] ${className}`}>
      <div className="max-w-5xl mx-auto px-5 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p className="text-xs text-[var(--text-muted)]">
          © {year} PsyPractice · {t("rights")}
        </p>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.id}
              href={`${legalBase}#${l.id}`}
              className="text-xs text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors"
            >
              {t(l.key)}
            </Link>
          ))}
        </nav>
      </div>

      {/* Zorunlu satıcı kimliği. Elektronik Ticarette Hizmet Sağlayıcı ve Aracı
          Hizmet Sağlayıcılar Hakkında Yönetmelik m.5 bu bilgilerin doğrudan
          ulaşılabilir şekilde, "iletişim" başlığı altında sunulmasını ister;
          yalnızca /legal içine gömülü olması yeterli değildir. Tek doğru kaynak
          lib/legalContent.ts MERCHANT sabitidir. */}
      <div className="max-w-5xl mx-auto px-5 pb-6 -mt-2">
        <p className="text-[11px] leading-relaxed text-[var(--text-muted)]">
          <span className="uppercase tracking-wide font-semibold">{t("contact")}</span>
          <br />
          {MERCHANT.legalName} ({t("merchantType")}) · {MERCHANT.address}
          <br />
          {t("taxLabel")}: {MERCHANT.taxOffice} / {MERCHANT.taxNo} ·{" "}
          <a href={`mailto:${MERCHANT.email}`} className="hover:text-[var(--accent)] transition-colors">
            {MERCHANT.email}
          </a>
          {MERCHANT.phone ? (
            <>
              {" · "}
              <a
                href={`tel:${MERCHANT.phone.replace(/\s/g, "")}`}
                className="hover:text-[var(--accent)] transition-colors"
              >
                {MERCHANT.phone}
              </a>
            </>
          ) : null}
        </p>
      </div>
    </footer>
  );
}
